"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterSelectInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const react_intl_1 = require("react-intl");
const react_hooks_1 = require("@dzambalaorg/react-hooks");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const utils_1 = require("../../utils");
const empty_1 = require("./empty");
const utils_2 = require("./utils");
const value_1 = require("./value");
const select_1 = require("./select");
const ParameterSelectInput = (props) => {
    const { multiple = true, prefix = "parameters", readOnly = false } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const form = (0, react_hook_form_1.useFormContext)();
    const ancestorPrefix = prefix.split(".").pop();
    const { fields, append, remove } = (0, react_hook_form_1.useFieldArray)({ name: prefix, control: form.control });
    const watchFields = (0, react_hook_form_1.useWatch)({ name: prefix });
    const parameters = fields.map((field, index) => ({
        ...field,
        ...watchFields[index],
    }));
    const [allParameters, setAllParameters] = (0, react_1.useState)(null);
    const [allNames, setAllNames] = (0, react_1.useState)([]);
    const availableNames = (0, utils_2.getAvailableNames)({ allNames, parameters });
    const disabledOptions = allNames.filter(p => (availableNames?.length ? !availableNames.includes(p) : true));
    const [isAddable, setIsAddable] = (0, react_1.useState)(!!availableNames);
    const handleOptionAdd = () => () => {
        const emptyParameter = (0, empty_1.getEmptyParameter)({ allNames, parameters });
        if (emptyParameter) {
            append(emptyParameter);
        }
    };
    const handleOptionDelete = (i) => () => {
        remove(i);
    };
    const { fn: getAllParameters } = (0, react_hooks_1.useApiCall)(api => api
        .fetchJson({
        url: "/parameter",
    })
        .then(json => {
        setAllParameters(json.rows);
        setAllNames((0, utils_1.uniqueBy)(json.rows, "parameterName").map(({ parameterName }) => parameterName));
    }), { success: false });
    (0, react_1.useEffect)(() => {
        if (!allParameters) {
            void getAllParameters();
        }
    }, [allParameters]);
    (0, react_1.useEffect)(() => {
        if (!parameters.length) {
            setIsAddable(true);
        }
        else {
            setIsAddable(!!availableNames);
        }
    }, [parameters]);
    return (0, react_1.useMemo)(() => ((0, jsx_runtime_1.jsxs)(material_1.Box, { mt: 2, children: [(0, jsx_runtime_1.jsxs)(material_1.Box, { sx: { display: "flex", alignItems: "center" }, children: [(0, jsx_runtime_1.jsx)(ui_kit_1.Typography, { sx: { mr: 1 }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: `form.labels.${ancestorPrefix}` }) }), multiple && isAddable ? ((0, jsx_runtime_1.jsx)(ui_kit_1.Tooltip, { arrow: false, title: formatMessage({ id: "form.tips.create" }), children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", size: "small", "aria-label": "add", onClick: handleOptionAdd(), children: (0, jsx_runtime_1.jsx)(icons_material_1.Add, { fontSize: "large", color: "primary" }) }) })) : null] }), parameters?.map((p, i) => ((0, jsx_runtime_1.jsxs)(material_1.Box, { mt: 1, mb: 1, display: "flex", justifyContent: "space-between", alignItems: "center", children: [(0, jsx_runtime_1.jsx)(material_1.Box, { flex: 1, children: (0, jsx_runtime_1.jsxs)(material_1.Paper, { sx: { p: 2, display: "flex", alignItems: "stretch", flex: 1, flexDirection: "column" }, children: [(0, jsx_runtime_1.jsx)(select_1.SelectInput, { name: "parameterName", prefix: `${prefix}[${i}]`, options: allNames, disabledOptions: disabledOptions }), (0, jsx_runtime_1.jsx)(value_1.ParameterValueInput, { prefix: `${prefix}[${i}]` })] }) }), multiple && ((0, jsx_runtime_1.jsx)(material_1.Box, { ml: 2, children: (0, jsx_runtime_1.jsx)(ui_kit_1.Tooltip, { title: formatMessage({ id: "form.tips.delete" }), children: (0, jsx_runtime_1.jsx)(ui_kit_1.Button, { intent: "icon", "aria-label": "delete", onClick: handleOptionDelete(i), children: (0, jsx_runtime_1.jsx)(icons_material_1.Delete, {}) }) }) }))] }, p.id)))] })), [allParameters, isAddable, multiple, readOnly, fields, watchFields]);
};
exports.ParameterSelectInput = ParameterSelectInput;
//# sourceMappingURL=index.js.map